import React, { useContext, useEffect, useState } from "react";
import { SearchBar } from "components";
import { useNavigate } from "react-router-dom";
import { customStylesSubsidy } from "utils/helpers/styles";
import Select from "react-select";
import {
  AssignTeam,
  AddUsersToMeal,
  BulkUserRemoveMealPlan,
  TeamRemoveMealPlan,
  ChangeSubsidyMealPlanUsers,
} from "alerts";
import { useManagePlan } from "contexts/ManagePlanContext";
import { MobXProviderContext } from "mobx-react";
import { isPresent } from "utils/helpers/array";
import { NotFound } from "components";
import { priceFormatterWithoutCurrency } from "utils/helpers/validation";
import userStore from "mobXstore/userStore";
import { useParams } from "react-router-dom";
import object from "utils/helpers/object";
import { SortingIcon } from "assets/img";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NotificationBanner, PageGuide } from "components";
import { isEmpty } from "utils/helpers/array";

function ManageUsers() {
  const {
    changeSubsidy,
    setChangeSubsidy,
    removeUser,
    setRemoveUser,
    assignTeam,
    setAssignTeam,
    addUsersToMeal,
    setAddUsersToMeal,
    confirmTeamRemove,
    setConfirmTeamRemove,
  } = useManagePlan();

  const { mealManagementStore } = useContext(MobXProviderContext);

  const [bulkUsers, setBulkUsers] = useState([]);
  const [subsidySelect, setSubsidySelect] = useState(null);

  const mealPlan = mealManagementStore.mealPlan;
  const teams = mealManagementStore.teams;
  const locationEmployees = mealManagementStore.locationEmployees;
  const [locEmployees, setLocationEmployees] = useState(
    mealPlan?.attributes?.employee_meal_plans
  );

  const locationID = userStore.locationID;
  const { mealPlanId } = useParams();

  const [teamOptions, setTeamOptions] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortedLocEmployees, setSortedLocEmployees] = useState(null);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setBulkUsers([]);

    if (subsidySelect?.value === "default") {
      let locEmployeesCopy = mealPlan?.attributes?.employee_meal_plans;

      locEmployeesCopy = locEmployeesCopy?.filter(
        (user) => user?.subsidy_type == null
      );

      setLocationEmployees(locEmployeesCopy);
    } else if (subsidySelect?.value === "custom") {
      let locEmployeesCopy = mealPlan?.attributes?.employee_meal_plans;
      locEmployeesCopy = locEmployeesCopy?.filter(
        (user) => user?.subsidy_type != null
      );
      setLocationEmployees(locEmployeesCopy);
    } else {
      setLocationEmployees(mealPlan?.attributes?.employee_meal_plans);
    }
  }, [subsidySelect, mealPlan]);

  useEffect(() => {
    !removeUser && setBulkUsers([]);
  }, [removeUser]);

  useEffect(() => {
    mealManagementStore.fetchTeams(locationID);

    if (object.isEmpty(mealPlan)) {
      mealManagementStore.fetchMealPlan(locationID, mealPlanId);
    }
  }, []);

  useEffect(() => {
    setSortedLocEmployees(locEmployees);
  }, [locEmployees]);

  useEffect(() => {
    if (!searchText) {
      setSortedLocEmployees(locEmployees);
    } else {
      const filtered = locEmployees?.filter((person) => {
        return (
          person?.first_name
            ?.toLowerCase()
            .includes(searchText?.toLowerCase()) ||
          person?.last_name
            ?.toLowerCase()
            .includes(searchText?.toLowerCase()) ||
          person?.email?.toLowerCase().includes(searchText?.toLowerCase()) ||
          person?.teams?.some((team) =>
            team?.name.toLowerCase().includes(searchText?.toLowerCase())
          )
        );
      });
      setSortedLocEmployees(filtered);
    }
  }, [searchText]);

  useEffect(() => {
    const options = teams?.map((team) => {
      return {
        label: team?.attributes?.name,
        value: team?.id,
      };
    });

    setTeamOptions(options);
  }, [teams.length]);

  useEffect(() => {
    setBulkUsers([]);
    const selectedTeamLabel = selectedTeam?.label;

    const locEmployeesCopy = mealPlan?.attributes?.employee_meal_plans?.filter(
      (user) =>
        !selectedTeamLabel ||
        user?.teams?.some((team) => team?.name == selectedTeamLabel)
    );
    setLocationEmployees(locEmployeesCopy);
  }, [selectedTeam]);

  const onEmployeeChecked = (e, person) => {
    const employeeId = person?.id;

    if (e.target.checked) {
      const found = mealPlan?.attributes?.employee_meal_plans?.find(
        (employee) => employee.id === employeeId
      );

      const alreadyInBulk = bulkUsers?.some(
        (user) => user?.employee_id === employeeId
      );

      if (!alreadyInBulk) {
        setBulkUsers((prev) => [
          ...prev,
          {
            id: found?.id,
            employee_id: employeeId,
            creation_source: person?.creation_source,
            ...found,
          },
        ]);
      }
    } else {
      setBulkUsers((prev) =>
        prev.filter((user) => user?.employee_id !== employeeId)
      );
    }
  };

  const sortLocationEmployees = (column) => {
    const newSortDirection =
      sortedColumn === column && sortDirection === "asc" ? "desc" : "asc";

    const sortedEmployees = sortedLocEmployees?.sort((a, b) => {
      let valueA = a[column];
      let valueB = b[column];

      // Handle sorting of "subsidy_type" (either 'Default' or 'Custom')
      if (column === "subsidy_type") {
        valueA = a[column] || "Default";
        valueB = b[column] || "Default";
      }

      if (valueA < valueB) return newSortDirection === "asc" ? -1 : 1;
      if (valueA > valueB) return newSortDirection === "asc" ? 1 : -1;
      return 0;
    });

    setSortedLocEmployees([...sortedEmployees]);
    setSortDirection(newSortDirection);
    setSortedColumn(column);
  };

  const addUsersToThisMeal = () => {
    if (isEmpty(locationEmployees))
      mealManagementStore.fetchEmployees(locationID).then((response) => {
        if (response?.data) setAddUsersToMeal(true);
      });
    else setAddUsersToMeal(true);
  };

  const totalUsersInTeams = mealPlan?.attributes?.team_meal_plans?.reduce(
    (sum, team) => sum + (team?.number_of_users || 0),
    0
  );

  return (
    <div className="d-col p-6 w-full relative">
      <div>
        <div className="d-row justify-between items-start">
          <button
            className="font-inter-regular text-[16px] text-hh-accent-dark"
            onClick={() => {
              navigate(-1);
            }}
          >
            <FontAwesomeIcon
              icon={faChevronLeft}
              size="xs"
              className="mr-2"
              style={{
                color: "#130f26",
              }}
            />
            Back to Meal Plan
          </button>

          <PageGuide />
        </div>

        {isPresent(mealPlan?.attributes?.banner_notifications) &&
          mealPlan?.attributes?.banner_notifications?.map((notification) => {
            return (
              <NotificationBanner
                key={notification?.id || notification?.long_message}
                message={notification?.long_message}
                messageType="warning"
                abilityToDismiss={false}
                hideClose={true}
                visible={true}
              />
            );
          })}

        <div className="d-row mt-[24px] items-center justify-between">
          <strong className="text-dark-gray text-[24px] font-inter-medium">
            Teams in {mealPlan?.attributes?.name}
          </strong>

          <button
            className="btn-blue-accent"
            onClick={() => {
              setAssignTeam(true);
            }}
          >
            Assign teams to this meal
          </button>
        </div>

        <small className="font-inter-regular text-secondary text-[16px]">
          Total users in teams in this meal plan: {totalUsersInTeams}
        </small>

        <p className="font-inter-regular max-w-[953px] mt-[8px] text-[14px] text-dark-gray">
          All users of the teams below are attached to this meal plan. Users
          added or removed from the following teams will be automatically added
          or removed from this meal plan. To manage users in teams go to
          <button
            className="text-catering ml-1 font-inter-regular text-[16px] hover:text-blue-700"
            onClick={() => {
              navigate("/uncatering/team");
            }}
          >
            Uncatering: Team.
          </button>
        </p>

        <div className="flex items-center space-x-2 my-[24px]">
          {mealPlan?.attributes?.team_meal_plans?.map((team) => (
            <div
              key={team?.id}
              className="bg-light-gray px-4 py-[12px] rounded-full flex items-center"
            >
              <span className="text-sm text-gray-700">{team?.team_name}</span>
              <button
                onClick={() => {
                  setConfirmTeamRemove(team?.team_id);
                }}
                className="ml-2 text-gray-700 text-xs"
              >
                ✕
              </button>
            </div>
          ))}
        </div>

        <NotFound
          data={mealPlan?.attributes?.team_meal_plans}
          message="No teams have been added to this meal plan. "
        />
      </div>

      <div className="h-1 w-full bg-accent-gray h-[.5px] my-[24px]" />

      <strong className="text-dark-gray text-[24px] font-inter-medium">
        All Users in {mealPlan?.attributes?.name}
      </strong>

      <small className="font-inter-regular text-secondary text-[16px]">
        Total users in this meal plan:{" "}
        {mealPlan?.attributes?.employee_meal_plans?.length}
      </small>

      <div className="d-row items-center justify-between mt-[16px]">
        <div className="d-row items-center">
          <SearchBar
            placeholder="Search"
            value={searchText}
            handleOnChange={(e) => setSearchText(e.target.value)}
          />

          <small className="font-inter-regular text-sm mx-[10px]">
            Filter by:
          </small>

          <Select
            styles={customStylesSubsidy({ preferences: true })}
            aria-labelledby="sort-by"
            aria-label="sort-by"
            placeholder="Subsidy type"
            closeMenuOnSelect
            isClearable
            onChange={(option) => setSubsidySelect(option)}
            options={[
              { label: "Custom", value: "custom" },
              { label: "Meal Plan Default", value: "default" },
            ]}
            className="w-[195px]"
          />

          <small className="font-inter-regular text-sm mx-[10px]">
            Filter by:
          </small>

          <Select
            styles={customStylesSubsidy({ preferences: true })}
            aria-labelledby="sort-by"
            aria-label="sort-by"
            placeholder="Teams"
            closeMenuOnSelect
            isClearable
            onChange={(option) => setSelectedTeam(option)}
            options={teamOptions}
            className="w-[195px]"
          />
        </div>

        <button
          className="btn-blue-accent"
          onClick={() => {
            addUsersToThisMeal();
          }}
        >
          Add users to this meal
        </button>
      </div>

      <div className="mt-8 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table className="w-full table-fixed overflow-visible divide-y divide-gray-300">
              <thead>
                <tr className="bg-light-gray">
                  <th
                    scope="col"
                    className="py-3.5 pl-4 pr-3 text-left text-sm font-inter-regular text-dark-gray sm:pl-3 "
                  ></th>
                  <th
                    scope="col"
                    className="px-1 w-1/8 py-3.5 text-left text-sm font-inter-regular text-dark-gray"
                  >
                    First name
                    <img
                      src={SortingIcon}
                      className="icon ml-1 mt-[1px] inline-block cursor-pointer"
                      onClick={() => sortLocationEmployees("first_name")}
                    />
                  </th>
                  <th
                    scope="col"
                    className="px-1 w-1/8 py-3.5 text-left text-sm font-inter-regular text-dark-gray"
                  >
                    Last name
                    <img
                      src={SortingIcon}
                      className="icon ml-1 mt-[1px] inline-block cursor-pointer"
                      onClick={() => sortLocationEmployees("last_name")}
                    />
                  </th>
                  <th
                    scope="col"
                    className="px-1 w-1/8 py-3.5 text-left text-sm font-inter-regular text-dark-gray"
                  >
                    Email
                    <img
                      src={SortingIcon}
                      className="icon ml-1 mt-[1px] inline-block cursor-pointer"
                      onClick={() => sortLocationEmployees("email")}
                    />
                  </th>
                  <th
                    scope="col"
                    className="px-1 w-1/8 py-3.5 text-left text-sm font-inter-regular text-dark-gray"
                  >
                    Team
                  </th>
                  <th
                    scope="col"
                    className="px-1 w-1/8 py-3.5 text-left text-sm font-inter-regular text-dark-gray"
                  >
                    Subsidy
                    <img
                      src={SortingIcon}
                      className="icon ml-1 mt-[1px] inline-block cursor-pointer"
                      onClick={() => sortLocationEmployees("subsidy_type")}
                    />
                  </th>
                  <th
                    scope="col"
                    className="px-1 w-1/8 py-3.5 text-left text-sm font-inter-regular text-dark-gray"
                  >
                    Subsidy Value ($)
                  </th>
                </tr>
              </thead>

              <tbody className="bg-white">
                {sortedLocEmployees?.map((person) => (
                  <tr key={person?.id} className="even:bg-light-gray">
                    <td className="py-4 w-1/8 max-w-0 break-words pl-1 pr-2 sm:pl-3">
                      <label className="inline-flex items-center">
                        <input
                          type="checkbox"
                          className="form-checkbox text-blue-600 h-4 w-4"
                          checked={bulkUsers?.some((u) => u.id == person?.id)}
                          onChange={(e) => {
                            onEmployeeChecked(e, person);
                          }}
                        />
                      </label>
                    </td>

                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-inter-medium text-dark-gray sm:pl-3">
                      {person?.first_name}
                    </td>

                    <td className="whitespace-nowrap px-3 py-4 text-sm font-inter-medium text-dark-gray">
                      {person?.last_name}
                    </td>

                    <td className="py-4 w-1/8 max-w-0 break-words pl-1 pr-1 text-sm font-inter-medium text-dark-gray sm:pl-3">
                      {person?.email}
                    </td>

                    <td className="px-1 w-1/8 max-w-0 break-words py-4 text-[13px] font-inter-medium text-dark-gray">
                      {person?.teams?.map((team, ind, arr) => {
                        return (
                          team?.name + (ind == arr?.length - 1 ? "" : ", ")
                        );
                      })}
                    </td>
                    <td className="px-1 w-1/8 max-w-0 break-words py-4 text-[13px] font-inter-medium text-dark-gray">
                      {person?.subsidy_type == null
                        ? "Meal Plan Default"
                        : "Custom"}
                    </td>

                    <td className="whitespace-nowrap px-3 py-4 text-sm font-inter-medium text-dark-gray">
                      {person?.subsidy_type == null ? (
                        <>
                          {!mealPlan?.attributes?.subsidy_type ? (
                            <small className="font-inter-medium text-sm text-dark-gray">
                              {priceFormatterWithoutCurrency(
                                mealPlan?.attributes?.standard_subsidy
                              )}
                            </small>
                          ) : mealPlan?.attributes?.subsidy_type == "weekly" ? (
                            <small className="font-inter-medium text-[14px] text-dark-gray">
                              {priceFormatterWithoutCurrency(
                                mealPlan?.attributes?.subsidy
                              )}{" "}
                              weekly
                            </small>
                          ) : (
                            <div className="d-col">
                              {mealPlan?.attributes?.daily_subsidy &&
                                Object.keys(
                                  mealPlan?.attributes?.daily_subsidy || {}
                                )
                                  ?.filter((day) =>
                                    mealPlan?.attributes?.days?.includes(day)
                                  )
                                  ?.map((day) => (
                                    <div
                                      key={day}
                                      className="d-row items-center"
                                    >
                                      <small className="mr-2 font-inter-medium text-dark-gray capitalize text-[11px]">
                                        {day?.substring(0, 3)}
                                      </small>
                                      <div className="items-center justify-center capitalize d-row rounded">
                                        <small className="font-inter-medium text-dark-gray text-[11px]">
                                          {priceFormatterWithoutCurrency(
                                            mealPlan?.attributes?.daily_subsidy[
                                              day
                                            ]
                                          )}
                                        </small>
                                      </div>
                                    </div>
                                  ))}
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          {person?.subsidy_type == "weekly" ? (
                            <small className="font-inter-medium text-[14px] text-dark-gray">
                              {priceFormatterWithoutCurrency(person?.subsidy)}{" "}
                              weekly
                            </small>
                          ) : (
                            <div className="d-col">
                              {person?.daily_subsidy &&
                                Object.keys(person?.daily_subsidy || {})
                                  ?.filter((day) =>
                                    mealPlan?.attributes?.days?.includes(day)
                                  )
                                  ?.map((day) => (
                                    <div className="d-row items-center">
                                      <small className="mr-2 font-inter-medium text-dark-gray capitalize text-[11px]">
                                        {day?.substring(0, 3)}
                                      </small>
                                      <div className="items-center justify-center capitalize d-row rounded">
                                        <small className="font-inter-medium text-dark-gray text-[11px]">
                                          {priceFormatterWithoutCurrency(
                                            person?.daily_subsidy[day]
                                          )}
                                        </small>
                                      </div>
                                    </div>
                                  ))}
                            </div>
                          )}
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <NotFound
              data={locEmployees}
              message="No users have been added to this meal plan. "
            />
          </div>
        </div>
      </div>

      {isPresent(bulkUsers) && (
        <div className="fixed bottom-0 right-0 d-row items-center justify-center left-0 ">
          <div className="btn-blue-accent rounded-3xl px-[32px] py-[16px] d-row items-center hover:bg-catering h-[48px] ">
            <small className="font-inter-medium text-[16px]">
              {bulkUsers?.length} user selected
            </small>
            <button
              className="font-inter-medium text-white px-[12px] underline text-[16px] py-0"
              onClick={() => setChangeSubsidy(true)}
            >
              Update subsidy
            </button>
            <button
              className="font-inter-medium text-white underline text-[16px] py-0"
              onClick={() => setRemoveUser(true)}
            >
              Remove user from meal plan
            </button>
          </div>
        </div>
      )}

      {changeSubsidy && (
        <ChangeSubsidyMealPlanUsers
          visible={changeSubsidy}
          setModal={setChangeSubsidy}
          meals={mealPlan?.attributes?.meals}
          mealPlanId={mealPlan?.id}
          bulkUsers={bulkUsers}
          bulkUserUpdate={true}
        />
      )}

      {assignTeam && (
        <AssignTeam
          visible={assignTeam}
          setModal={setAssignTeam}
          teams={teams}
          mealPlanId={mealPlan?.id}
        />
      )}
      {addUsersToMeal && (
        <AddUsersToMeal
          visible={addUsersToMeal}
          setModal={setAddUsersToMeal}
          users={locationEmployees}
          mealPlanId={mealPlan?.id}
        />
      )}
      {confirmTeamRemove && (
        <TeamRemoveMealPlan
          visible={confirmTeamRemove}
          setModal={setConfirmTeamRemove}
          mealPlanId={mealPlan?.id}
          meals={mealPlan?.attributes?.meals}
        />
      )}
      {removeUser && (
        <BulkUserRemoveMealPlan
          visible={removeUser}
          setModal={setRemoveUser}
          mealPlanId={mealPlan?.id}
          bulkUsers={bulkUsers}
          meals={mealPlan?.attributes?.meals}
        />
      )}
    </div>
  );
}

export default ManageUsers;
